import PosModal from '@/components/auth/PosModal';
import StoreSelectorModal from '@/components/auth/StoreSelectorModal';
import { useSync } from '@/hooks/useSync';
import { selectUser } from '@/redux/auth/authSlice';
import { useAppSelector } from '@/redux/hooks';
import { Layout } from 'antd';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import MyErrorBoundary from '../ErrorBoundray/ErrorBoundray';
import Seo from '../components/Seo';
import SuspenseLoader from '../components/SuspenseLoader';
import findItemByUrl from '../helpers/findItemByUrl';
import SidebarLayout from './Sidebar.layout';
import { generateItems } from './menuItems';

const { Content } = Layout;

const MainLayout = () => {
  const { t } = useTranslation(['common']);
  const user = useAppSelector(selectUser);

  useSync();

  const items = generateItems(t, user);
  const url = window.location.pathname;
  const activeMenuTab = findItemByUrl(url, items);

  return (
    <>
      <Seo title={activeMenuTab?.label ? `${activeMenuTab.label}` : 'Orino'} />
      <Layout className="min-h-screen">
        <SidebarLayout items={items} user={user} />
        <Layout>
          {/* <Header /> */}
          <Content className="bg-[var(--bg-clr)] flex flex-col min-h-0">
            <div className="flex-1 overflow-hidden bg-white">
              <Suspense fallback={<SuspenseLoader />}>
                <MyErrorBoundary>
                  <Outlet />
                </MyErrorBoundary>
              </Suspense>
            </div>

            {/* Store/Device Modals */}
            {user && !user?.activeStore ? (
              <StoreSelectorModal />
            ) : user && !user.devicePOS ? (
              <PosModal />
            ) : null}
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default MainLayout;
